// @flow
import { createAction } from 'redux-act';

export const fetchChecksums = createAction('Fetch Checksums');
export const fetchChecksumsSuccess = createAction('Fetch Checksums Success');
export const fetchChecksumsFailed = createAction('Fetch Checksums Failed');